import React from 'react';

const MobileContainer = props => {
  return <div className="br-xs" {...props} />;
};

export default MobileContainer;
